import 'babel-polyfill'
import Vue from 'vue'
import App from './App'

import router from './router'
import 'es6-promise/auto'
import Vuex from 'vuex'
import Vuelidate from 'vuelidate'
import store from './store/store'
import {
    TableComponent,
    TableColumn
} from 'vue-table-component'
import moment from 'moment'
import Toasted from 'vue-toasted'
import Vue2Filters from 'vue2-filters'
import VModal from 'vue-js-modal'
import VueScrollTo from 'vue-scrollto'
import 'lodash'
import MagBackNav from './components/layout/mag-back-nav.vue'
import formats from './lib/number-formats'
import VueI18n from 'vue-i18n'
import {MAGDatepickerSingle} from '@mag/mag-components-datepicker'
import MAGSidebar from '@mag/mag-components-sidebar'

var Options = {
    position: 'bottom-center',
    duration: '3500',
    router: router,
    fullWidth: true,
    fitToScreen: true,
    closeOnSwipe: false,
    singleton: true,
    action: {
        text: 'X',
        onClick: (e, toastObject) => {
            toastObject.goAway(0)
        },
        class: 'text-white'
    }
}

Vue.use(Vuex)
Vue.use(Vuelidate)
Vue.use(Toasted, Options)
Vue.use(Vue2Filters)
Vue.use(VModal)
Vue.use(VueI18n)

let numberFormats = formats.formats
const i18n = new VueI18n({
    numberFormats
})

Vue.use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})
Vue.component('table-component', TableComponent)
Vue.component('table-column', TableColumn)
Vue.component('mag-back-nav', MagBackNav)
Vue.component('mag-datepicker-single', MAGDatepickerSingle)
Vue.component('mag-sidebar', MAGSidebar)
Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).local().format('LLLL')
    }
})

Vue.filter('splitPascal', function (value) {
    if (value) {
        return value.replace(/([A-Z][a-z])/g, ' $1')
    }
})

Vue.filter('noValue', function (value) {
    if (value) {
        return value
    }
    return '(no value)'
})



export default new Vue({
    el: '#app',
    store,
    router,
    components: {
        App
    },
    template: '<App/>',
    i18n
})
